import { render, staticRenderFns } from "./PageExercise.vue?vue&type=template&id=2824a976"
import script from "./PageExercise.vue?vue&type=script&lang=js"
export * from "./PageExercise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports